module.exports = __webpack_public_path__ + "media/images/background_home-e6ea171e.jpg";